export default ({ language }) => language;
